// accounts.js
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default (Alpine) => {
    Alpine.data("accounts", ({ email }) => ({
        swiper: null,
        email: email || null,
        excludedProducts: [],
        cartProducts: [],
        excludedTags: ['algolia-ignore', 'ShipInsure'],
        orderId: null,
        addAddress: false,
        addressTitle: null,
        addAddressButton: null,

        init() {
          this.hydrate();

          this.onPageShow = (e) => {
              this.hydrate();
          };
          window.addEventListener('pageshow', this.onPageShow);

          window.addEventListener('address-form-shown', this.addressFormShown);
          window.addEventListener('address-form-hidden', this.addressFormHidden);
        },

        addressFormHidden() {

          const addressTitle = document.querySelector('[data-address-title]');
          const addAddressButton = document.querySelector('[data-add-address-button]');

          if (addressTitle) {
            addressTitle.classList.remove('!hidden');
          }
          if (addAddressButton) {
            addAddressButton.classList.remove('!hidden');
          }
        },

        addressFormShown() {
          const addressTitle = document.querySelector('[data-address-title]');
          const addAddressButton = document.querySelector('[data-add-address-button]');

          if (addressTitle) {
            addressTitle.classList.add('!hidden');
          }
          if (addAddressButton) {
            addAddressButton.classList.add('!hidden');
          }
        },

        hydrate() {
          const slider = this.$el.querySelector('.recommended-products-slider');

          if (!slider) return;

          const recentProducts = slider.getAttribute('data-recent-products');

          if (!recentProducts) {
            this.initSwiper();
            return;
          }
          
          const hasSlides = !!slider?.querySelector('.swiper-slide');
        
          if (!hasSlides) {
            this.fetchRecommendedProducts();
          } else {
            this.$nextTick(() => this.initSwiper());
          }
        },

        initSwiper() {
          const root = this.$el;
        
          const slider = root.querySelector('.recommended-products-slider');
          const swiperEl = root.querySelector('.recommended-products-slider .swiper');
          if (!slider || !swiperEl) return;
        
          const prevButton = root.querySelector('.recommended-products-slider .swiper-button-prev');
          const nextButton = root.querySelector('.recommended-products-slider .swiper-button-next');
        
          if (!prevButton || !nextButton) return;
        
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        
          this.swiper = new Swiper(swiperEl, {
            modules: [Navigation],
            slidesPerView: 2,
            spaceBetween: 2,
            watchOverflow: false,
            navigation: {
              nextEl: nextButton,
              prevEl: prevButton,
              lockClass: 'swiper-lock-disabled',
            },
          });
        
          this.$nextTick(() => {
              this.swiper?.update();
              this.swiper?.navigation?.update();
              prevButton.classList.remove('swiper-button-lock');
              nextButton.classList.remove('swiper-button-lock');
          });
        },

        async fetchRecommendedProducts(excludeProductId = null) {
          const slider = this.$el.querySelector('.recommended-products-slider');
          if (!slider) return;
        
          const recentProducts = slider.getAttribute('data-recent-products');
          if (!recentProducts) return;
        
          const recentProductIds = recentProducts.split(',');
        
          for (const id of recentProductIds) {
            try {
              const res = await fetch(
                `/recommendations/products.json?product_id=${encodeURIComponent(id)}&intent=related&limit=8`
              );
        
              if (!res.ok) throw new Error(`Request failed: ${res.status}`);
        
              const data = await res.json();
        
              if (!data?.products?.length) continue;
        
              this.renderRecommendedProducts(slider, data, excludeProductId);
              
              return; 
            } catch (err) {
              console.warn(`Recommendation failed for ${id}`, err);
            }
          }
          console.warn("No recommendations found for any recent product");
        },

        fetchCartProducts() {
          fetch('/cart/add.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(response => response.json())
          .then(data => {
          })
          .catch(error => {
            console.error('Error fetching cart products:', error);
          });
        },
          
        renderRecommendedProducts(slider, data) {
            const products = data?.products || [];

            const excludedProductsByTags = products.filter(p => this.excludedTags.some(tag => p.tags.includes(tag)));

            this.excludedProducts.push(...excludedProductsByTags.map(p => p.id));

            if (!products.length) return;
          
            // minimal markup example (adjust to your theme)
            slider.innerHTML = `
               <div class="border border-[#00000066]">
                  <div class="flex justify-between items-center py-6 md:py-10 px-5 md:px-10 relative">
                      <span class="font-anton uppercase text-[24px] md:text-[32px]">Our Customers Love These</span>
                      <div class="relative flex gap-8 h-5 items-end">
                          <button class="swiper-button-prev !static"></button>
                          <button class="swiper-button-next !static"></button>
                      </div>
                  </div>
                  <div class="swiper">
                      <div class="swiper-wrapper">
                      ${products.filter(p => !this.excludedProducts.includes(p.id) && !this.cartProducts.includes(p.id)).map(p => `
                          <div data-product-id="${p.id}" class="swiper-slide transition-all duration-300 !h-auto flex-col justify-between items-center lg:items-start lg:flex-row flex bg-[#0000000F] p-3 md:p-10 gap-10"
                          style="background-color: #0000000F;">
                              <div class="w-[120px] min-w-[120px]">
                              <a href="${p.url}" class="w-full h-full">
                                  ${p.featured_image ? `<img src="${p.featured_image}" alt="${(p.title || '').replace(/"/g, '&quot;')}" loading="lazy" class="w-full h-full object-contain">` : ''}
                              </a>
                              </div>
                              <div class="flex !h-min flex-col justify-center items-center lg:!items-start gap-3 w-full">
                              <div class="yotpo-widget-instance" data-yotpo-instance-id="442240" data-yotpo-product-id="${p.id}" data-yotpo-cart-product-id="${p.id}" data-yotpo-section-id="accounts"></div>
                              <a href="${p.url}" class="mb-5">
                                  <div class="h-7">
                                    <span class="font-bebasNeue text-[20px] font-bold line-clamp-2 text-center md:text-left">${p.title}</span>
                                  </div>
                              </a>
                              ${p.price_min < p.price_max ? `<span class="font-bebasNeue text-base">Starting at <span class="font-bold">${this.formatMoney(p.price_min)}</span></span>` : `<span class="font-bebasNeue text-base font-bold">${this.formatMoney(p.price)}</span>`}
                              ${p.variants.length > 1 ? `<a href="${p.url}" class="w-full font-bebasNeue flex justify-center items-center text-lg uppercase bg-black text-white h-12 px-4 py-2 hover:bg-[#f5d500] hover:text-black transition-all duration-300 text-center !whitespace-nowrap">Choose Options</a>` : `<button @click="addToCart(${p.id},${p.variants[0].id})" class="w-full h-12 font-bebasNeue text-lg uppercase bg-black text-white px-4 py-2 hover:bg-[#f5d500] hover:text-black transition-all duration-300 text-center !whitespace-nowrap">Add to Cart</button>`}
                              </div>
                          </div>
                      `).join('')}
                      </div>
                      </div>
                  </div>
                </div>
            `;
          
            this.$nextTick(() => {
              if (this.swiper) this.swiper.destroy(true, true);
              this.swiper = null;

              this.initSwiper();
      
                this.$nextTick(() => {
                  if (window.yotpo?.refreshWidgets) window.yotpo.refreshWidgets();
                  else if (window.Yotpo?.initWidgets) window.Yotpo.initWidgets();
                });
            });
        },

        addToCart(productId, variantId) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          })

          .then(response => response.json())
          .then(data => {
            Rebuy.SmartCart.show();

            this.excludedProducts.push(productId);
            
            this.removeSlideFromSwiper(productId);
          })
          .catch(error => {
            console.error('Error:', error);
          });

          
        },

        removeSlideFromSwiper(productId) {
          this.swiper?.slides.forEach(slide => {



            if (Number(slide.getAttribute('data-product-id')) === Number(productId)) {
              slide.style.opacity = '0 !important';
              setTimeout(() => {
              slide.style.display = 'none !important';
              slide.remove();
              this.$nextTick(() => {
                this.swiper?.update();
              });
              }, 300);
            }
          });
        },
          
        formatMoney(price) {
          return (price / 100).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
          });
      }
          
    }));
  };